import { render } from "./Scorecard.vue?vue&type=template&id=44bdbdc6&scoped=true&ts=true"
import script from "./Scorecard.vue?vue&type=script&lang=ts"
export * from "./Scorecard.vue?vue&type=script&lang=ts"

import "./Scorecard.vue?vue&type=style&index=0&id=44bdbdc6&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-44bdbdc6"]])

export default __exports__